import { style } from '@vanilla-extract/css';
import { nToPx, themeVars } from '@tundr/theme';

export const mainContainerClass = style({
  position: 'relative',
  display: 'flex',
  height: '100%',
});

export const leftSectionBackgroundClass = style({
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  height: '100%',
  flexBasis: '30%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const leftSectionContentClass = style({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
  justifyContent: 'center',
  fontSize: themeVars.font.size.h2,
  gap: themeVars.space.x8,
  width: '60%',
});

export const logoClass = style({
  width: 170,
});

export const messageClass = style({
  lineHeight: 1.5,
  fontSize: themeVars.font.size.textLg,
  whiteSpace: 'break-spaces',
});

export const mainContentBackgroundClass = style({
  flexBasis: '70%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const mainContentClass = style({
  display: 'flex',
  flexDirection: 'column',
  width: 475,
});

export const appVersionClass = style({
  position: 'fixed',
  height: 10,
  bottom: 0,
  padding: nToPx(0, themeVars.space.x5),
  width: '100%',
  justifyContent: 'flex-start',
  color: themeVars.colors.neutrals.black100,
  fontSize: themeVars.font.size.textSm,
  marginBottom: themeVars.space.x4,
});
